/** @format */

import * as XLSX from 'xlsx';
import { formatoTipo } from './tipos';
import { textoFecha, textoFechaHora } from './fechas';
import { urlAbsolutaOT } from './descargas';

/** Exporta las ordenes visibles (o las seleccionadas) a un .xlsx */
export const exportarOrdenesAExcel = (ordenes, nombreArchivo = 'ordenes-de-trabajo') => {
	const filas = ordenes.map(orden => ({
		'Fecha actividad': textoFecha(orden.fechaActividad),
		'Fecha OT': textoFechaHora(orden.fechaOT),
		'Fecha certificado': orden.fechaCertificado ? textoFecha(orden.fechaCertificado) : '',
		Folio: orden.folio,
		Tipo: formatoTipo(orden.tipo, orden.emergencia),
		Estado: orden.esCertificada ? 'Certificada' : 'Por certificar',
		Emergencia: orden.emergencia ? 'Si' : 'No',
		Firmada: orden.tieneFirma ? 'Si' : 'No',
		Tecnico: orden.tecnico,
		Cliente: orden.lugar,
		RUT: orden.clienteRut || '',
		Compartida: orden.compartida ? 'Si' : 'No',
		Enlace: urlAbsolutaOT(orden.urlVer),
	}));

	const hoja = XLSX.utils.json_to_sheet(filas);
	const libro = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(libro, hoja, 'Ordenes');
	XLSX.writeFile(libro, `${nombreArchivo}.xlsx`);
	return filas.length;
};
